<template>
  <div class="homepage">
    <h1>Home</h1>
    <p>
      Welcome to the personal website of John Knotts.
    </p>
    <img src="../assets/family.png" alt="my crew" />
    <p>
      I'm a stay-at-home dad and I love my wife and kids. They’re amazing people
      and so much fun to be around — my crew for life. If I'm not with them I'm
      usually running in the mountains or dabbling in software development.
    </p>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
};
</script>

<style>
.homepage {
  text-align: center;
}
</style>
